import { Directive, ElementRef, OnInit, Input, inject } from '@angular/core';
import { environment } from '@env/environment';

@Directive({ selector: '[appProductCatalogue]' })
export class ProductCatalogueDirective implements OnInit {
    private elementRef = inject(ElementRef);

    @Input({ required: true }) stelmachID!: string;

    ngOnInit(): void {
        this.elementRef.nativeElement.src = environment.serverUrl + `api/public/product/catalogue/image/${this.stelmachID}`;
    }
}
